import { Component, OnInit } from '@angular/core';


import { MunicipalitiesService } from './../../services/municipalities/municipalities.service';
import { SeoService } from './../../services/seo.service';
import *  as  data from './colombia.json';

declare var Jquery: any;
declare var $: any;

@Component({
  selector: 'app-municipalities',
  templateUrl: './municipalities.component.html',
  styleUrls: ['./municipalities.component.scss']
})
export class MunicipalitiesComponent implements OnInit {

  chapters: any;
  years: any;
  yearActive: any = false;
  departaments: any;
  indicator: any = false;
  public municipalitiyActive: any = null;

  public selectedDepartment: any;
  public selectedMunicipality: any;
  public departments: any;
  public municipalities: any;
  public municipalitySelectedMap: any;
  public municipalityActive: any;
  public codes:any= [];


  indicatorsCharts = {
    labels: [],
    data: [],
    legend: false,
    type: 'horizontalBar',
    pieChartOptions: {
      'backgroundColor': [
        "#F28321",
        "#006738",
        "#ED1651",
        "#B94E24",
        "#682062",
        "#ECCD1A",
        "#C1932B",
        "#AC2950",
        "#34495e"
      ]
    }

  };


  constructor(
    private municipalitiesService: MunicipalitiesService,
    private seoService: SeoService
  ) {
    this.seoService.setTagsPage({
      title: 'Cptur | Proyectos',
      type: 'website',
      description: 'Proyectos',
      image: '/assets/images/logo.png'
    });
  }

  ngOnInit() {

    // this.selectedDepartment = this.departments[Math.floor(Math.random() * this.departments.length)].code;  
    this.getYears();
  }


  getYears() {
    this.municipalitiesService.getYears().subscribe(years => {
      this.years = years;
      this.yearActive = this.years[0];
      this.getDepartaments();
    })
  }

  setYear(year) {
    console.log(year);
    this.yearActive = year;
    this.getIndicator();
  }

  // this.selectedDepartment = this.departaments[Math.floor(Math.random()* this.departaments.length)];;  


  getDepartaments() {
    this.municipalitiesService.getDepartaments().subscribe(departaments => {
      this.departaments = departaments;
      this.selectedDepartment = this.departaments[Math.floor(Math.random()* this.departaments.length)].code;
      this.getMunicipalities(this.selectedDepartment, this.yearActive.year)

    })
  }

  getMunicipalities(depCode = this.selectedDepartment, year = this.yearActive.year) {
    this.municipalitiesService.getMunicipalities(depCode).subscribe(municipalities => {
      this.municipalities = municipalities;
      this.selectedMunicipality = this.municipalities[0].code;
      this.emitSelectEventMunicipality(this.selectedMunicipality);
      this.getIndicator(this.municipalities[0].code, this.yearActive.year)
      this.getMunicipalityObject(this.municipalities[0].code);
      this.codes = municipalities;

    })
  }

  getIndicator(munCode = this.selectedMunicipality, year = this.yearActive.year) {

    this.municipalitiesService.getIndicator(munCode, year).subscribe(indicator => {


      if (indicator == null) {
        this.indicator = false;
        return;
      }

      this.indicator = indicator;

      let labels = [];
      let data = [];
      this.indicator.ictrcReportsList.forEach(report => {
        labels.push(report.criterio);
        data.push(report.score)
      })

      this.indicatorsCharts.labels = labels;
      this.indicatorsCharts.data = data;

    })
  }


  searchMunicipalities(e) {
    this.getMunicipalities(e.code);
  }


  searchMunicipalitiesIndicators(e) {

    if (e.code) {

      if (e.code.length == 4) {
        this.selectedMunicipality = '0' + e.code;
        this.getIndicator(this.selectedMunicipality);
        this.getMunicipalityObject('0' + e.code);

      } else {
        this.selectedMunicipality = e.code;
        this.getIndicator(this.selectedMunicipality);
        this.getMunicipalityObject(e.code);
      }

      this.emitSelectEventMunicipality(e.code);
    } else {

      if (e.length == 4) {
        this.selectedMunicipality = '0' + e;
        this.getIndicator(this.selectedMunicipality);
        this.getMunicipalityObject('0' + e);

      } else {
        this.selectedMunicipality = e;
        this.getIndicator(this.selectedMunicipality);
        this.getMunicipalityObject(e);
      }

      this.emitSelectEventMunicipality(e);

    }

  }

  emitSelectEventMunicipality(e) 
  {
    this.municipalitySelectedMap = parseInt(e).toString();
  }


  getMunicipalityObject(code) {
    this.municipalityActive = this.municipalities.find(el => el.code == code);
  }

}
